import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useSuperNetwork from "./hooks/useSuperNetwork";  
  
const SuperNetwork = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
}) => {
  const superNetworkData = useSuperNetwork(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData
  );

  return (
    <div class={`container container-fluid ${superNetworkData?.lookupType === 'external' ? 'popup' : ''}`}>
      <ButtonsSection ctaButtons={superNetworkData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {superNetworkData.screen_title} -{" "}
          <span className="heading-cod">{superNetworkData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={superNetworkData.formFields}
        dropdownValues={superNetworkData.dropdownValues}
        paramsData={superNetworkData.paramsData}
        updataParamData={superNetworkData.updateParamData}
        disabledFields={superNetworkData.disabledFields}
      />
      <ButtonsSection ctaButtons={superNetworkData.ctaButtons} />
      <DisplayTable
        selectMode={superNetworkData.selectMode}
        data={superNetworkData.data}
        parmKey={superNetworkData.parmKey}
        menuOptions={superNetworkData.menuOptions}
        tableHeaders={superNetworkData.columnDef}
        setRowData={superNetworkData.setRowData}
        selectedPriceSchedules={superNetworkData.selectedRows}
        setSelectedPriceSchedules={superNetworkData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={superNetworkData.first}
          rows={superNetworkData.rows}
          totalRecords={superNetworkData.totalRecords}
          currentPage={superNetworkData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={superNetworkData.onPageChange}
        />
      </div>
      {superNetworkData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={superNetworkData.isConfirmationModalOpen}
          onRequestClose={superNetworkData.closeConfirmationModal}
          onBack={superNetworkData.closeConfirmationModal}
          onSave={superNetworkData.deleteSuperNetwork}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={superNetworkData.setSelectedOption}
        />
      )}
    </div>
  );
};  
  
export default SuperNetwork;  